// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: 1488167444
// </auto-generated>
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEventType,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Observable, Subject, Subscription } from 'rxjs';
import { SmartListResult, SmartListCriteria } from 'carehub-shared/smartlist';
import { Utils } from 'carehub-shared/utils';

import { NotificationInfo } from './models/common/notificationinfo';
import { UserNotification } from './models/common/usernotification';
import { DismissNotificationsRequest } from './models/common/dismissnotificationsrequest';

@Injectable({
  providedIn: 'root',
})
export class UserNotificationApiService {
  constructor(protected http: HttpClient) {}

  getRecent(): Observable<NotificationInfo> {
    const url = environment.chiliSauceApiRoot + `/api/UserNotification`;
    return this.http.get<NotificationInfo>(url);
  }

  getUpdates(newerThan: number): Observable<UserNotification[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/UserNotification/newer/${newerThan}`;
    return this.http.get<UserNotification[]>(url);
  }

  loadMore(olderThan: number): Observable<UserNotification[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/UserNotification/older/${olderThan}`;
    return this.http.get<UserNotification[]>(url);
  }

  dismissNotifications(req: DismissNotificationsRequest): Observable<any> {
    const url = environment.chiliSauceApiRoot + `/api/UserNotification/dismiss`;
    return this.http.put<any>(url, req);
  }
}
